import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { Breadcrumbs, breakpoints, Icon, useMediaQuery } from 'gd-design-library';
import { ROUTES } from '@constants';
import { CategoriesBreadcrumb } from '@services';

interface CategoriesBreadcrumbsProps {
  categories: CategoriesBreadcrumb[]
}

export const CategoriesBreadcrumbs: React.FC<CategoriesBreadcrumbsProps> = ({ categories }) => {
  const [ isMounted, setIsMounted ] = useState(false);
  const isMobileOrTablet = useMediaQuery(`(max-width: ${breakpoints.md})`);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <Breadcrumbs
      items={ [ <Link key='products' href={ ROUTES.catalog }>Products</Link>,
        ...categories.map(category => (
          <Link key={ category.id } href={
            `${ROUTES.catalog}/${category.key}`
          }>
            {category.name}
          </Link>
        )) ] }
      separator={
        <Icon
          name='arrowRight'
          width={ (isMounted && isMobileOrTablet) ? 8 : 10 }
          height={ (isMounted && isMobileOrTablet) ? 8 : 10 }
        />
      }
    />
  );
};
